import { createFileRoute } from '@tanstack/react-router';

import { requireRoute } from '@/router/guards';
import DeviceEdit from '@/ui/pages/DeviceEdit/DeviceEdit';

export const Route = createFileRoute('/_dashboard/devices/$id/edit')({
  beforeLoad: requireRoute('/devices/$id/edit'),
  component: DeviceEdit,
});
